// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__2COtW","info":"UpdateTermsInfo_info__2eJ4_"};